export const fontFamily = {
  primary: 'MediumLLWeb',
};

export const fontWeight = {
  regular: 400,
  book: 500,
  semiBold: 600,
  bold: 800,
};
